import React, { Suspense , useEffect , useState } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store/userStore";
import "./App.css";
import Header from "components/common/Header/Header";
import AppRouter from "./routes/AppRouter";
import GlobalErrorHandler from "./components/ErrorHandler/GlobalErrorHandler/GlobalErrorHandler";

function App() {

  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    function sessionInvalidationListener(event) {
      if (event.key === 'sessionInvalidated') {
        setSessionExpired(true);
      }
    }

    window.addEventListener('storage', sessionInvalidationListener);

    return () => {
      window.removeEventListener('storage', sessionInvalidationListener);
    };
  }, []);

  const handleAlertClose = () => {
    setSessionExpired(false);
    window.location.href = process.env.REACT_APP_LOGIN_URL;
  };

  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Header />
        </Switch>
        <GlobalErrorHandler />
        {sessionExpired && (
            <div className="custom-alert">
              <p>Your session has expired. You will be redirected to the login page.</p>
              <button onClick={handleAlertClose}>OK</button>
            </div>
        )}
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <main>
              <AppRouter />
            </main>
          </Switch>
        </Suspense>
      </Router>
    </Provider>
  );
}

export default App;
